export default __webpack_public_path__ + "static/media/background.9e3c50ae.svg";